import axios from "axios";  
import { BASE_URL } from "../../assets/constant";
import { createHeaders } from "../../utils/Utils";

 

export const getQuestionPendingList = async (data) => {  
      const headers = createHeaders()
  return await axios.get(`${BASE_URL}admin/chats/pending`, headers);
};
export const getQuestionList = async (data) => {  
      const headers = createHeaders()
  return await axios.get(`${BASE_URL}admin/chats/approved`, headers);
};
export const getDashboardData = async (data) => {  
      const headers = createHeaders()
  return await axios.post(`${BASE_URL}dashboard`,null, headers);
};

export const getQuestionCountsAPI = async () => {
  const headers = createHeaders();
  return await axios.get(`${BASE_URL}admin/question-counts`, headers);
};
export const deleteQuestionAPI = async (data) => {  
      const headers = createHeaders()
  return await axios.delete(`${BASE_URL}admin/reject/${data}`, headers);
};
export const addQuestionAPI = async (data) => {  
      const headers = createHeaders()
  return await axios.post(`${BASE_URL}admin/add`,data,headers);
};
//!update question and approve
export const approveQuestionAPI = async (data) => {  
      const headers = createHeaders()
      console.log("data",data);
      
  return await axios.post(`${BASE_URL}admin/approve/${data.id}`,data,headers);
};
// export const addQuestionAPI = async (data) => {  
//       const headers = createHeaders()
//   return await axios.post(`${BASE_URL}add`,data, headers);
// };
// export const getQuestionListAPI = async (data) => {  
//       const headers = createHeaders()
//   return await axios.get(`${BASE_URL}admin/get-questions`, headers);
// };
export const getQuestionListAPI = async (data) => {  
      const headers = createHeaders()
  return await axios.post(`${BASE_URL}admin/get-questions`,data, headers);
};
export const getPendingQuestionListAPI = async (data) => {  
      const headers = createHeaders()
  return await axios.post(`${BASE_URL}admin/get-pending-questions`,data, headers);
};
export const getRejectedQuestionListAPI = async (data) => {  
      const headers = createHeaders()
  return await axios.post(`${BASE_URL}admin/get-rejected-questions`,data, headers);
};
export const getUserReqQuestionListAPI = async (data) => {  
      const headers = createHeaders()
  return await axios.post(`${BASE_URL}admin/get-user-questions`,data, headers);
};
export const getUnAnsQuestionListAPI = async (data) => {  
      const headers = createHeaders()
  return await axios.post(`${BASE_URL}admin/get-unanswered-questions`,data, headers);
};